import { useCallback, useState } from "react";

import { useReportContext } from "../../../report-context";

import { useAuth } from "@/context/auth-context";
import { useDeleteReportColumn } from "@/queries";
import { ReportColumn } from "@/types/evaluate";

interface UseColumnDeletionProps {
  reportId: number;
}

export const useColumnDeletion = ({ reportId }: UseColumnDeletionProps) => {
  const userToken = useAuth()?.userToken || "";
  const [isDeleteConfirmationOpen, setIsDeleteConfirmationOpen] = useState(false);
  const { mutate: deleteColumn } = useDeleteReportColumn(userToken, reportId);
  const { closeSidebar, selectedColumn, setSelectedColumn } = useReportContext();

  const handleDeleteColumn = useCallback((column: ReportColumn) => {
    if (column.id && column.id !== undefined) {
      setIsDeleteConfirmationOpen(true);
    }
  }, []);

  const handleConfirmDelete = useCallback(
    (column: ReportColumn) => {
      if (column.id) {
        // Check if the column being deleted is currently selected
        const isCurrentlySelected = selectedColumn?.id === column.id;

        deleteColumn(column.id);
        setIsDeleteConfirmationOpen(false);

        // If the deleted column was selected, close sidebar and clear selection
        if (isCurrentlySelected) {
          closeSidebar();
          setSelectedColumn(null);
        }
      }
    },
    [deleteColumn, selectedColumn, closeSidebar, setSelectedColumn],
  );

  const handleCancelDelete = useCallback(() => {
    setIsDeleteConfirmationOpen(false);
  }, []);

  return {
    isDeleteConfirmationOpen,
    setIsDeleteConfirmationOpen,
    handleDeleteColumn,
    handleConfirmDelete,
    handleCancelDelete,
  };
};
